import { useMemo } from "react";
import { sortBy } from "lodash";
import type { UseBlockListProps } from "../BlockList/useCategorizedBlockList";
import { categoryIsPresent } from "../BlockList/utils/categoryIsPresent";
import { processBlockCategories } from "../BlockList/utils/processBlockCategories";
import type { BlockExport } from "../BuilderUI.types";

export const ELEMENT_CATEGORIES = [
  "Profile fields",
  "General",
  "Layout",
  "Text",
  "Actions",
  "Media",
  "Basic",
];

type BlockTuple = [string, BlockExport];

export const useCategorizedElementsList = ({ blocks }: UseBlockListProps) =>
  useMemo(() => {
    const categoriesMap = processBlockCategories({ blocks });

    const categoryOrderMap = ELEMENT_CATEGORIES.reduce<Record<string, number>>(
      (acc, name, idx) => {
        acc[name] = idx;
        return acc;
      },
      {},
    );

    const elementCategories = sortBy(
      Array.from(categoriesMap.values()).filter(
        category => category.name in categoryOrderMap,
      ),
      category => categoryOrderMap[category.name],
    );

    return elementCategories.map(category => ({
      ...category,
      blocks: Object.entries(blocks)
        .filter(([type, block]) => {
          const meta = block.meta;

          return (
            type !== "root" &&
            categoryIsPresent(block, category) &&
            meta.isHidden !== true
          );
        })
        .map(([type, block]): BlockTuple => [type, block]),
    }));
  }, [blocks]);
